import styled, { css } from "styled-components";

interface IOrganizationContainerProps {
  isMain: boolean;
}

export const OrganizationContainer = styled.li<IOrganizationContainerProps>`
  list-style: none;

  button {
    width: 100%;
    box-sizing: border-box;
  }

  img {
    margin-bottom: 0.9688rem;

    width: 230px;
    height: 132px;
    border-radius: 8px;

    ${({ isMain }) =>
      isMain &&
      css`
        object-fit: contain;
      `}
  }

  .texts {
    display: flex;
    flex-direction: column;
    gap: 0.4844rem;

    margin-bottom: 0.9688rem;

    max-width: 230px;

    span {
      font: 600 0.8125rem/1.0156rem "Inter";
      color: ${({ theme }) => theme.console.pageTitleColor};
    }

    p {
      font: 400 0.8125rem/1.2188rem "Inter";
      color: ${({ theme }) => theme.console.pageSubtitleColor} !important;

      margin: 0;
    }

    span,
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
`;

interface IFallbackImageProps {
  width: number;
  height: number;
  backgroundColor: string;
}

export const FallbackImage = styled.div<IFallbackImageProps>`
  margin-bottom: 0.9688rem;

  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  border-radius: 8px;

  background-color: ${({ backgroundColor }) => backgroundColor ?? "#303030"};
`;
